import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AuthStateChange {
  type: 'login' | 'logout';
  timestamp: Date;
}

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  private authStateSubject = new Subject<AuthStateChange>();

  // Observable para que otros servicios puedan suscribirse
  public authState$ = this.authStateSubject.asObservable();

  /**
   * Notifica que se hizo login exitoso
   */
  notifyLogin(): void {
    const change: AuthStateChange = {
      type: 'login',
      timestamp: new Date(),
    };
    this.authStateSubject.next(change);
    console.log('🔔 AuthStateService: Login notificado', change);
  }

  /**
   * Notifica que se hizo logout
   */
  notifyLogout(): void {
    const change: AuthStateChange = {
      type: 'logout',
      timestamp: new Date(),
    };
    this.authStateSubject.next(change);
    console.log('🔔 AuthStateService: Logout notificado', change);
  }
}
